import { render, staticRenderFns } from "./HusbandryRoomActivityReportDay.vue?vue&type=template&id=35fa62dc&"
import script from "./HusbandryRoomActivityReportDay.vue?vue&type=script&lang=js&"
export * from "./HusbandryRoomActivityReportDay.vue?vue&type=script&lang=js&"
import style0 from "./HusbandryRoomActivityReportDay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow})
